export const RETURN_TO_KEY = 'savaf:returnTo';

export function isSafeReturnPath(value: string | null | undefined): value is `/${string}` {
  if (!value?.startsWith('/') || value.startsWith('//')) return false;

  try {
    return new URL(value, 'https://savaf.invalid').origin === 'https://savaf.invalid';
  } catch {
    return false;
  }
}

export function saveReturnPath(value: string): void {
  if (!isSafeReturnPath(value)) return;

  try {
    sessionStorage.setItem(RETURN_TO_KEY, value);
  } catch {
    /* sessionStorage unavailable */
  }
}

export function takeReturnPath(): `/${string}` | undefined {
  try {
    const value = sessionStorage.getItem(RETURN_TO_KEY);
    sessionStorage.removeItem(RETURN_TO_KEY);
    return isSafeReturnPath(value) ? value : undefined;
  } catch {
    return undefined;
  }
}
